import { GetCulpritReceivedCorrectiveParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritReceivedCorrectiveImages/getCulpritReceivedCorrectiveImages.type';
import { getCulpritReceivedCorrectiveImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritReceivedCorrectiveImages/getCulpritReceivedCorrectiveImagesFunction';
import { queryOptions } from '@tanstack/react-query';

export const getCulpritReceivedCorrectiveImagesOptions = ({
  id,
}: GetCulpritReceivedCorrectiveParamsType) => {
  return queryOptions({
    queryKey: ['GET_CULPRIT_RECEIVED_CORRECTIVE_IMAGES_OPTIONS', id],
    queryFn: () => getCulpritReceivedCorrectiveImagesFunction({ id }),
  });
};
